<!--
 * @FileDescription: 图表数据组件
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-28 15:39:08
 -->
<template>
    <dv-border-box12 class="border-box" :styleId="styleType" :order="order">
        <div :index='chartId' ref="chartDom" class="chart-container" :styleId="styleType">
            >
        </div>
    </dv-border-box12>
</template>

<script>
export default {
    name: "chartContainer",
};
</script>

<script setup>
import * as echarts from 'echarts';
import { ref, onMounted, defineProps } from 'vue';
import { frontDataNew } from './chartData';
import { BorderBox12 as DvBorderBox12 } from '@kjgl77/datav-vue3'
// import activeJson from "/public/activeChartData.json"

console.log("frontDataNew", frontDataNew);

let props = defineProps({
    chartId: String,
    order: String,
    styleType: String,
})

// console.log(props);

const chartDom = ref(null);
const styleType = ref(props.styleType);

const graduate_url = 'image://http://223.2.9.189:8080/image/hat32.png'
// console.log(frontDataNew)

const ScreenBaseRatio =  () => {
    let clientWidth = window.innerWidth || document.documentElement.clientWidth;
    let clientHeight = window.innerHeight || document.documentElement.innerHeight;
    let widthRatio = clientWidth / 2560;
    let heightRatio = clientHeight / 1440;

    let screenRatio = widthRatio * 0.8 + heightRatio * 0.2;

    return screenRatio;
}

let screenRatio = ScreenBaseRatio();

const SmartFontsize = (originSize) => {
    return screenRatio * originSize * 0.85;
}

const SmartPaddingPixel = (originPixel) => {
    if(screenRatio <= 0.5) {
        return 1;
    }
    else {
        return originPixel * screenRatio;
    }
}

const SmartOtherPixel = (originPixel) => {
    return originPixel * screenRatio;
}

onMounted(() => {
    console.log('dom', chartDom.value);
    let chart = echarts.init(chartDom.value)

    let frontDataNew = {}


    // fetch("http://223.2.9.189:8080/activeChartData.json")
    fetch("/activeChartData.json")
        .then(function (response) {
            // 如果请求成功
            if (response.ok) {
                // 解析 JSON 数据
                return response.json();
            } else {
                throw new Error("无法加载 JSON 文件");
            }
        })
        .then(function (jsonData) {
            // 可以在这里使用 jsonData 对象进行相关操作

            // async function getUnionYearList() {
            //     requestApi.getUnionList().then((res) => {
            //         let yearTemp = []
            //         var yearNewList = []
            //         console.log("js中的res", res.data.data[0]);
            //         //遍历拿到年份数组
            //         for (let i = 0; i < res.data.data[0].length; i++) {

            //             yearTemp.push(res.data.data[0][i].buildTime.slice(0, 4))

            //         }
            //         var yearList = repeat1(yearTemp)

            //         //字符串数组转数字类型数组

            //         for (let j = 0; j < yearList.length; j++) {
            //             yearNewList.push(parseInt(yearList[j]))
            //         }
            //         yearNewList.sort(function (a, b) { return a - b });
            //         console.log("yearTemp", yearNewList);
            //         return yearNewList
            //     })
            // }

            //返回没有重复值的数组
            // function repeat1(arr) {
            //     var temp = [];
            //     for (let i = 0; i < arr.length; i++) {
            //         if (temp.indexOf(arr[i]) == -1) {
            //             temp.push(arr[i])
            //         }
            //     }
            //     return temp
            // }
            /*
                就业落实情况bar图数据
            */
            // 就业落实情况，第一个柱状图

            let graYearList = jsonData.graYearList
            let graduateTypeData = jsonData.graduateTypeData

            // console.log("graduateTypeData",graduateTypeData);
            // let graduateTypeData = {
            //     'work': [1649, 2133, 2028], // 工作
            //     'local': [1263, 1438, 1547], // 国内升学
            //     'foriegn': [332, 317, 312], // 国外升学
            //     'successRate':[77.24, 91.72, 89.69], // 落实率
            //     'localRate': [30.07, 33.92, 36.07], // 国内升学率
            //     'foriegnRate': [7.91, 7.48, 7.15] // 境外升学率
            // }

            /*
                就业落实行业情况bar图数据 -- 动态
            */
            // 毕业生落实情况行业数据
            let workData = jsonData.workData
            // let workData = [
            //     [46.33, 9.12, 6.49, 5.88, 5.81, 5.45, 4.28, 3.24, 2.82, 2.5, 2.39].reverse(), // 20
            //     [37.6, 14.48, 9.5, 2.4, 2.49, 6, 4.89, 4.03, 3.45, 3.36, 4.12].reverse(), // 21
            //     [38.32, 10.51, 7.66, 3.86, 3.93, 9.88, 5, 4.18, 2.6, 3.74, 5.57].reverse() // 22
            // ]
            let currentWorkDataIndex = 0; // 就业行业索引 对应上面list索引号
            // let currentWorkYearIndex = 0; // 就业行业year

            let workYearsList = jsonData.workYearsList
            // let workYearsList = ['2020', '2021', '2022'];  // 就业行业数据年份list,
            // console.log("yearsListNew", getUnionYearList());
            function dynamicWorkData(workChart) {
                currentWorkDataIndex = (currentWorkDataIndex + 1) % (workData.length);
                // currentWorkYearIndex = (currentWorkYearIndex + 1) % workYearsList.length;
                // console.log("index:",currentWorkDataIndex);
                // console.log("workYearsList:",workYearsList[currentWorkDataIndex]);
                workChart.setOption({
                    title: {
                        text: '历届毕业生就业行业分布-' + workYearsList[currentWorkDataIndex]
                    },
                    series: [
                        {
                            data: workData[currentWorkDataIndex]
                        },
                    ],
                });
            }

            /*
                毕业生国内就业流向pie图数据 -- 动态
            */
            let workFlowCountryData = jsonData.workFlowCountryData
            // let workFlowCountryData = [
            //     [65.28, 5.49, 5.43, 2.5, 1.59, 19.71],  // 20
            //     [71.31, 4.14, 3.67, 2.4, 2.12, 16.36], // 21
            //     [69.51, 4.42, 4.17, 3.09, 2.06, 16.75] // 22
            // ]

            let workFlowCountryName = jsonData.workFlowCountryName
            // let workFlowCountryName = [
            //     '江苏', '浙江', '上海', '广东', '贵州', '其他'
            // ]

            let currentWorkFlowIndex = 0;  // 就业流向索引 对应上面list索引号
            let workFlowYearsList = jsonData.workFlowYearsList
            // let workFlowYearsList = ['2020', '2021', '2022'];  // 就业流向数据年份list,

            let workFlowPieChange = (pieChartFst) => {
                currentWorkFlowIndex = (currentWorkFlowIndex + 1) % workFlowCountryData.length;
                // currentWorkFlowIndex = (currentWorkFlowYearIndex + 1) % workFlowYearsList.length;
                let dynamicData = workFlowCountryData[currentWorkFlowIndex];
                // console.log("index:",currentWorkFlowIndex);
                // console.log("workFlowCountryData:",workFlowYearsList[currentWorkFlowIndex]);
                pieChartFst.setOption({
                    title: {
                        text: '历届毕业生国内就业流向-' + workFlowYearsList[currentWorkFlowIndex]
                    },
                    series: [
                        {
                            data: [
                                { value: dynamicData[0], name: workFlowCountryName[0] },
                                { value: dynamicData[1], name: workFlowCountryName[1] },
                                { value: dynamicData[2], name: workFlowCountryName[2] },
                                { value: dynamicData[3], name: workFlowCountryName[3] },
                                { value: dynamicData[4], name: workFlowCountryName[4] },
                                { value: dynamicData[5], name: workFlowCountryName[5] },
                            ].sort(function (a, b) {
                                return b.value - a.value;
                            })
                        },
                    ],
                });
            }

            /*
                毕业生国内就业单位bar图数据 -- 动态
            */
            let workPlaceData = jsonData.workPlaceData
            // let workPlaceData = [
            //     [40.02, 32.44, 12.37, 3.7, 3.52], // 20
            //     [56.08, 26.38, 9.8, 2.64, 1.92], // 21
            //     [43.35, 30.36, 14.26, 3.19, 3.18] // 22
            // ];
            let workPlaceIndex = 0;
            let workPlaceYearsList = jsonData.workPlaceYearsList
            // let workPlaceYearsList = ['2020', '2021', '2022'];  // 就业单位数据年份list,

            let workPlaceBarChange = (barChart) => {
                workPlaceIndex = (workPlaceIndex + 1) % workPlaceData.length;
                let currentPlaceData = workPlaceData[workPlaceIndex];
                barChart.setOption({
                    title: {
                        text: '历届毕业生就业单位情况-' + workPlaceYearsList[workPlaceIndex]
                    },
                    series: [
                        {
                            data: [
                                {
                                    value: currentPlaceData[0], itemStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#3DF2F2' },
                                            { offset: 0.5, color: '#2995D9' },
                                            { offset: 1, color: '#074E8C' }
                                        ])
                                    }
                                },
                                {
                                    value: currentPlaceData[1], itemStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#F2CB05' },
                                            { offset: 0.5, color: '#F28705' },
                                            { offset: 1, color: '#D95204' }
                                        ])
                                    }
                                },
                                {
                                    value: currentPlaceData[2], itemStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#DEF2B3' },
                                            { offset: 0.5, color: '#55A605' },
                                            { offset: 1, color: '#488C04' },

                                        ])
                                    }
                                },
                                {
                                    value: currentPlaceData[3], itemStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#F24405' },
                                            { offset: 0.5, color: '#F25C05' },
                                            { offset: 1, color: '#F27405' },

                                        ])
                                    }
                                },
                                {
                                    value: currentPlaceData[4], itemStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#66CAF2' },
                                            { offset: 0.5, color: '#0388A6' },
                                            { offset: 1, color: '#03658C' },
                                        ])
                                    }
                                },
                            ]
                        },
                    ],
                });
            }


            /*
                联合办学学校数量line图数据 -- 动态
            */
            // function testData() {
            //     var unionYears = getUnionYearList()
            //     console.log("unionYears", unionYears);
            // }

            let unionSchoolYears = jsonData.unionSchoolYears
            // let unionSchoolYears = [
            //     1987, 1999, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023
            // ] // 年份list

            let fullUnionSchoolNums = jsonData.fullUnionSchoolNums
            // let fullUnionSchoolNums = [
            //     2, 3, 4, 5, 7, 10, 13, 13, 14, 15, 15, 18, 22, 29, 34, 35
            // ] // 完整数量

            let begUnionSchoolNums = jsonData.begUnionSchoolNums
            // let begUnionSchoolNums = [
            //     2, 3, 4
            // ] // 初始数量 显示3个

            let dynamicUnionSchoolNums = jsonData.dynamicUnionSchoolNums
            // let dynamicUnionSchoolNums = [
            //     2, 3, 4
            // ] // 动态变化数组，不断增加个数，以动态绘制
            let nextYearIndex = 3; // 下一个年份索引号

            let unionSchoolLineChange = (lineChart) => {
                nextYearIndex = (nextYearIndex + 1) % unionSchoolYears.length;
                if (nextYearIndex == 0) {
                    dynamicUnionSchoolNums = [...begUnionSchoolNums];
                    nextYearIndex = 3;
                }
                else {
                    dynamicUnionSchoolNums.push(fullUnionSchoolNums[nextYearIndex])
                }
                lineChart.setOption({
                    series: [
                        {
                            data: dynamicUnionSchoolNums,
                        }
                    ],
                });
            }


            /*
                联合办学学校类型pie图数据 -- 动态
            */
            let unionSchoolTypeNum = jsonData.unionSchoolTypeNum
            // let unionSchoolTypeNum = [
            //     [6, 9, 9, 9, 10, 11, 11, 12, 14, 16, 18, 19], // 中学   
            //     [1, 1, 4, 4, 4, 4, 4, 5, 7, 10, 12, 12], // 小学
            //     [0, 0, 0, 0, 0, 0, 0, 1, 1, 3, 4, 4], // 幼儿园
            // ]

            let currentSchoolTypeIndex = 0;
            let schoolTypeYears = jsonData.schoolTypeYears
            // let schoolTypeYears = [
            //     2012, 2013, 2014, 2015, 2016, 2017, 2018,
            //     2019, 2020, 2021, 2022, 2023
            // ] // 展示数量变化的关键年份
            let schoolTypePieChange = (pieChart) => {
                currentSchoolTypeIndex = (currentSchoolTypeIndex + 1) % schoolTypeYears.length;
                pieChart.setOption({
                    title: {
                        text: '联合办学学校类型构成-' + schoolTypeYears[currentSchoolTypeIndex],
                    },
                    series: [
                        {
                            data: [
                                {
                                    value: unionSchoolTypeNum[0][currentSchoolTypeIndex],
                                    name: '中学'
                                },
                                {
                                    value: unionSchoolTypeNum[1][currentSchoolTypeIndex],
                                    name: '小学'
                                },
                                {
                                    value: unionSchoolTypeNum[2][currentSchoolTypeIndex],
                                    name: '幼儿园'
                                },
                            ]
                        }
                    ],
                });
            }


            frontDataNew = {
                'maps': [],
                'charts': [
                    // 0 -> line type chart 1
                    {
                        'chartOpt': { // 毕业生落实变化情况bar
                            title: {
                                text: '历届毕业生落实变化情况',
                                textAligh: 'center',
                                x: 'center',
                                top: '1%',
                                textStyle: {
                                    color: 'rgba(255, 255, 255, 1)',
                                    fontWeight: 'bolder',
                                    fontFamily: 'Microsoft YaHei',
                                    fontSize: SmartFontsize(24),
                                }
                            },
                            legend: {
                                type: "scroll",
                                bottom: '1%',
                                x: 'center',
                                orient: 'horizontal',
                                height: '14%',
                                textStyle: {
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    fontFamily: 'Microsoft YaHei',
                                    fontWeight: 'bold',
                                    fontSize: SmartFontsize(16),
                                },
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                borderRadius: 10,
                                padding: SmartPaddingPixel(8),
                                itemGap: 12,
                                pageTextStyle: {
                                    color: "#fff"
                                },
                                pageIconColor: '#fff',
                                pageIconInactiveColor: '#2f4554',

                            },
                            grid: {
                                top: '20%',
                                left: '2%',
                                bottom: '16%',
                                right: '1%',
                                containLabel: true
                            },
                            tooltip: {
                                trigger: 'axis'
                            },
                            xAxis: {
                                type: 'category',
                                data: graYearList,
                                axisLabel: {
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontSize: SmartFontsize(18)
                                }
                            },
                            yAxis: [
                                {
                                    type: 'value',
                                    name: '人数',
                                    alignTicks: true,
                                    nameTextStyle: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: SmartFontsize(14),
                                        fontWeight: 'bold'
                                    },
                                    axisLabel: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        formatter: '{value} 人',
                                        fontSize: SmartFontsize(16)
                                    },
                                    splitLine: {
                                        lineStyle: {
                                            color: 'rgba(255, 255, 255, 0.3)'
                                        }
                                    },
                                    max: 'dataMax',
                                    min: 0
                                },
                                {
                                    type: 'value',
                                    name: '人数比例',
                                    position: 'right',
                                    nameTextStyle: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: SmartFontsize(14),
                                        fontWeight: 'bold'
                                    },
                                    splitLine: {
                                        lineStyle: {
                                            color: 'rgba(255, 255, 255, 0.3)'
                                        }
                                    },
                                    axisLabel: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        formatter: '{value} %',
                                        fontSize: SmartFontsize(16)
                                    }
                                }
                            ],
                            series: [
                                {
                                    name: '就业',
                                    type: 'bar',
                                    stack: 'total',
                                    barWidth: '28%',
                                    label: {
                                        show: true,
                                        fontSize: SmartFontsize(20),
                                        fontWeight: 'bolder',
                                        color: 'rgba(255, 255, 255, 1)',
                                    },
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    itemStyle: {
                                        opacity: 0.8
                                    },
                                    z: 10,
                                    // data: [1649, 2133, 2028]
                                    data: graduateTypeData["work"]
                                },
                                {
                                    name: '国内\n升学',
                                    type: 'bar',
                                    stack: 'total',
                                    barWidth: '28%',
                                    label: {
                                        show: true,
                                        fontSize: SmartFontsize(18),
                                        fontWeight: 'bolder',
                                        color: 'rgba(255, 255, 255, 1)',
                                    },
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    itemStyle: {
                                        opacity: 0.8
                                    },
                                    z: 10,
                                    // data: [1263, 1438, 1547]
                                    data: graduateTypeData["local"]
                                },
                                {
                                    name: '国外\n升学',
                                    type: 'bar',
                                    stack: 'total',
                                    barWidth: '28%',
                                    label: {
                                        show: true,
                                        fontSize: SmartFontsize(18),
                                        fontWeight: 'bolder',
                                        color: 'rgba(255, 255, 255, 1)',
                                    },
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    itemStyle: {
                                        opacity: 0.8
                                    },
                                    z: 10,
                                    // data: [332, 317, 312]
                                    data: graduateTypeData["foriegn"]
                                },
                                {
                                    name: '毕业\n落实率',
                                    type: 'line',
                                    data: graduateTypeData["successRate"],
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    // symbol: 'diamond', 
                                    symbolSize: 8,
                                    lineStyle: {
                                        width: 4
                                    },
                                    yAxisIndex: 1
                                },
                                {
                                    name: '国内\n升学率',
                                    type: 'line',
                                    data: graduateTypeData["localRate"],
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    // symbol: 'diamond', 
                                    symbolSize: 8,
                                    lineStyle: {
                                        width: 4
                                    },
                                    yAxisIndex: 1
                                },
                                {
                                    name: '出境\n升学率',
                                    type: 'line',
                                    data: graduateTypeData["foriegnRate"],
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    // symbol: 'diamond', 
                                    symbolSize: 8,
                                    lineStyle: {
                                        width: 4
                                    },
                                    yAxisIndex: 1
                                },
                            ]
                        }
                    },
                    {
                        'chartOpt': { // 历届毕业生就业行业分布 icon dynamic bar
                            title: {
                                text: '历届毕业生就业行业分布-2020',
                                textAligh: 'center',
                                x: 'center',
                                top: '1%',
                                textStyle: {
                                    color: 'rgba(255, 255, 255, 1)',
                                    fontWeight: 'bolder',
                                    fontFamily: 'Microsoft YaHei',
                                    fontSize: SmartFontsize(24),
                                }
                            },
                            tooltip: {
                                formatter: '{a0}<br/>{b0}: {c0}%'
                            },
                            grid: {
                                top: '8%',
                                left: '4%',
                                right: '16%',
                                bottom: '2%',
                                containLabel: true
                            },
                            yAxis: [
                                {
                                    type: 'category',
                                    axisTick: { show: false },
                                    nameTextStyle: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: SmartFontsize(16),
                                        fontWeight: 'bold'
                                    },
                                    axisLabel: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: SmartFontsize(14),
                                    },
                                    data: [
                                        '教育', '信息软件', '文体娱乐', '金融业', '公共管理', '制造', '电热燃水',
                                        '批发零售', '租赁商务', '建筑', '科研技术'
                                    ]// .reverse()
                                }
                            ],
                            xAxis: [
                                {
                                    type: 'value',
                                    max: 50,
                                    name: '人数比例',
                                    nameTextStyle: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: SmartFontsize(14),
                                        fontWeight: 'bold'
                                    },
                                    axisLabel: {
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        formatter: '{value} %',
                                    }
                                }
                            ],
                            series: [
                                {
                                    name: '就业行业',
                                    type: 'pictorialBar',
                                    symbol: graduate_url,
                                    symbolRepeat: 'fixed',
                                    symbolMargin: '5%',
                                    symbolClip: true,
                                    symbolSize: SmartOtherPixel(30),
                                    symbolBoundingData: 50,
                                    data: workData[currentWorkDataIndex],
                                    label: {
                                        show: true,
                                        formatter: '{c} %',
                                        position: 'right',
                                        offset: [10, 0],
                                        color: 'rgba(41, 156, 187, 0.9)',
                                        fontSize: SmartFontsize(16)
                                    },
                                    z: 10
                                },
                                {
                                    // full data
                                    type: 'pictorialBar',
                                    itemStyle: {
                                        opacity: 0.2
                                    },
                                    tooltip: {
                                        show: false,
                                    },
                                    symbolRepeat: 'fixed',
                                    symbolMargin: '5%',
                                    symbol: graduate_url,
                                    symbolSize: SmartOtherPixel(30),
                                    symbolBoundingData: 50,
                                    data: [50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50],
                                    z: 5
                                }
                            ]
                        },
                        'dynamicFunc': dynamicWorkData
                    },
                    {
                        'chartOpt': {
                            title: {
                                text: '历届毕业生国内就业流向-2020',
                                x: 'center',
                                top: '2%',
                                textStyle: {
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontWeight: 'bolder',
                                    fontFamily: 'Microsoft YaHei',
                                    fontSize: SmartFontsize(24),
                                }
                            },
                            legend: {
                                orient: 'horizontal',
                                type: 'scroll',
                                bottom: '7%',
                                height: '15%',
                                x: 'center',
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                borderRadius: 10,
                                show: true,
                                padding: SmartPaddingPixel(8),
                                itemWidth: SmartOtherPixel(25),
                                itemHeight: SmartOtherPixel(25),
                                textStyle: {
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: SmartFontsize(18)
                                },
                                pageTextStyle: {
                                    color: "#fff"
                                },
                                pageIconColor: '#fff',
                                pageIconInactiveColor: '#2f4554',
                                
                            },
                            visualMap: {
                                show: false,
                                min: 1.5,
                                max: 72,
                                inRange: {
                                    // colorLightness: [0, 1]
                                }
                            },
                            series: [
                                {
                                    name: '国内就业流向',
                                    type: 'pie',
                                    radius: ['20%', '70%'],
                                    center: ['50%', '46%'],
                                    avoidLabelOverlap: false,
                                    itemStyle: {
                                        borderRadius: 8,
                                        shadowBlur: 200,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    label: {
                                        show: true,
                                        position: 'inside',
                                        formatter: '{c} %',
                                        fontSize: SmartFontsize(20),
                                        fontWeight: 'bold'
                                    },
                                    // minShowLabelAngle: 10,
                                    emphasis: {
                                        label: {
                                            show: true,
                                            fontSize: SmartFontsize(22),
                                            fontWeight: 'bold',
                                            borderColor: 'black',
                                            color: 'white',
                                            formatter: '{b}\n{c} %'
                                        }
                                    },
                                    data: [
                                        { value: workFlowCountryData[currentWorkFlowIndex][0], name: workFlowCountryName[0] },
                                        { value: workFlowCountryData[currentWorkFlowIndex][1], name: workFlowCountryName[1] },
                                        { value: workFlowCountryData[currentWorkFlowIndex][2], name: workFlowCountryName[2] },
                                        { value: workFlowCountryData[currentWorkFlowIndex][3], name: workFlowCountryName[3] },
                                        { value: workFlowCountryData[currentWorkFlowIndex][4], name: workFlowCountryName[4] },
                                        { value: workFlowCountryData[currentWorkFlowIndex][5], name: workFlowCountryName[5] },
                                    ].sort(function (a, b) {
                                        return b.value - a.value;
                                    }),
                                }
                            ]
                        },
                        'dynamicFunc': workFlowPieChange
                    },
                    {
                        'chartOpt': {
                            title: {
                                text: '历届毕业生就业单位情况-2020',
                                textAligh: 'center',
                                x: 'center',
                                top: '2%',
                                textStyle: {
                                    color: 'rgba(255, 255, 255, 1)',
                                    fontWeight: 'bolder',
                                    fontFamily: 'Microsoft YaHei',
                                    fontSize: SmartFontsize(24),
                                }
                            },
                            tooltip: {

                            },
                            grid: {
                                top: '10%',
                                left: '4%',
                                right: '4%',
                                bottom: '4%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                axisTick: { show: false },
                                data: ['其他企业', '中初教育', '国有企业', '三资企业', '机关单位'],
                                axisLabel: {
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontSize: SmartFontsize(14),
                                    fontWeight: 'bold'
                                }
                            },
                            yAxis: {
                                type: 'value',
                                axisLabel: {
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    formatter: '{value} %'
                                }
                            },
                            itemStyle: {
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                                shadowBlur: 10,
                                shadowOffsetX: 2,
                                shadowOffsetY: 2,
                            },
                            series: [
                                {
                                    name: '就业单位',
                                    type: 'bar',
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    data: [
                                        {
                                            value: workPlaceData[workPlaceIndex][0],
                                            itemStyle: {
                                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                    { offset: 0, color: '#3DF2F2' },
                                                    { offset: 0.5, color: '#2995D9' },
                                                    { offset: 1, color: '#074E8C' }
                                                ])
                                            }
                                        },
                                        {
                                            value: workPlaceData[workPlaceIndex][1],
                                            itemStyle: {
                                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                    { offset: 0, color: '#F2CB05' },
                                                    { offset: 0.5, color: '#F28705' },
                                                    { offset: 1, color: '#D95204' }
                                                ])
                                            }
                                        },
                                        {
                                            value: workPlaceData[workPlaceIndex][2],
                                            itemStyle: {
                                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                    { offset: 0, color: '#DEF2B3' },
                                                    { offset: 0.5, color: '#55A605' },
                                                    { offset: 1, color: '#488C04' },

                                                ])
                                            }
                                        },
                                        {
                                            value: workPlaceData[workPlaceIndex][3],
                                            itemStyle: {
                                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                    { offset: 0, color: '#F24405' },
                                                    { offset: 0.5, color: '#F25C05' },
                                                    { offset: 1, color: '#F27405' },

                                                ])
                                            }
                                        },
                                        {
                                            value: workPlaceData[workPlaceIndex][4],
                                            itemStyle: {
                                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                    { offset: 0, color: '#66CAF2' },
                                                    { offset: 0.5, color: '#0388A6' },
                                                    { offset: 1, color: '#03658C' },
                                                ])
                                            }
                                        },
                                    ],
                                    label: {
                                        show: true,
                                        fontSize: SmartFontsize(18),
                                        fontWeight: 'bolder',
                                        formatter: '{c} %',
                                        color: 'rgb(255, 255, 255)'
                                    },
                                },
                            ]
                        },
                        'dynamicFunc': workPlaceBarChange
                    },
                    {
                        'chartOpt': {
                            title: {
                                text: '联合办学学校数量变化情况',
                                textAligh: 'center',
                                x: 'center',
                                top: '2%',
                                textStyle: {
                                    color: 'rgba(255, 255, 255, 1)',
                                    fontWeight: 'bolder',
                                    fontFamily: 'Microsoft YaHei',
                                    fontSize: SmartFontsize(24),
                                }
                            },
                            tooltip: {
                                trigger: 'axis'
                            },
                            grid: {
                                top: '12%',
                                left: '4%',
                                right: '6%',
                                bottom: '4%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                data: unionSchoolYears,
                                axisLabel: {
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    formatter: '{value} 年',
                                    fontSize: SmartFontsize(14),
                                    fontWeight: 'bold'
                                }
                            },
                            yAxis: {
                                type: 'value',
                                axisLabel: {
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    formatter: '{value} 所',
                                    fontSize: SmartFontsize(14),
                                    fontWeight: 'bold'
                                }
                            },
                            series: [
                                {
                                    name: '联合办学学校数量',
                                    type: 'line',
                                    smooth: true,
                                    data: dynamicUnionSchoolNums,
                                    showSymbol: false,
                                    lineStyle: {
                                        color: '#5B9DD4',
                                        width: 5
                                    },
                                    areaStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: '#3DF2F2' },
                                            { offset: 0.5, color: '#2995D9' },
                                            { offset: 1, color: '#074E8C' }
                                        ])
                                    },
                                    animationDuration: 500,
                                    markLine: {
                                        data: [
                                            { type: 'max', name: '数量' },
                                            [
                                                {
                                                    symbol: 'none',
                                                    x: '20%',
                                                    yAxis: 'max',
                                                },
                                                {
                                                    symbol: 'circle',
                                                    label: {
                                                        position: 'start',
                                                        formatter: 'Max',
                                                        fontSize: SmartFontsize(14),
                                                        color: 'rgba(255, 255, 255, 0.9)'
                                                    },
                                                    type: 'max',
                                                    name: '最高点'
                                                }
                                            ]
                                        ]
                                    }
                                }
                            ]
                        },
                        'dynamicFunc': unionSchoolLineChange
                    },
                    {
                        'chartOpt': {
                            title: {
                                text: '联合办学学校类型构成-2012',
                                x: 'center',
                                top: '2%',
                                textStyle: {
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontWeight: 'bolder',
                                    fontFamily: 'Microsoft YaHei',
                                    fontSize: SmartFontsize(24),
                                }
                            },
                            legend: {
                                orient: 'horizontal',
                                bottom: '4%',
                                x: 'center',
                                height: '15%',
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                borderRadius: 10,
                                show: true,
                                padding: SmartPaddingPixel(8),
                                textStyle: {
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: SmartFontsize(16)
                                }, 
                                itemWidth: SmartOtherPixel(28),
                                itemHeight: SmartOtherPixel(28),
                            },
                            visualMap: {
                                show: false,
                                min: 1.5,
                                max: 72,
                                inRange: {
                                    // colorLightness: [0, 1]
                                }
                            },
                            series: [
                                {
                                    name: '联合办学学校类型构成',
                                    type: 'pie',
                                    roseType: 'radius',
                                    radius: ['20%', '70%'],
                                    center: ['50%', '48%'],
                                    avoidLabelOverlap: false,
                                    showEmptyCircle: false,
                                    itemStyle: {
                                        borderRadius: 8,
                                        shadowBlur: 200,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    label: {
                                        show: true,
                                        position: 'inside',
                                        formatter: '{c} 所',
                                        fontSize: SmartFontsize(18),
                                        fontWeight: 'bold',
                                        color: 'white',
                                    },
                                    minShowLabelAngle: 4,
                                    emphasis: {
                                        label: {
                                            show: true,
                                            fontSize: SmartFontsize(20),
                                            fontWeight: 'bold',
                                            borderColor: 'black',
                                            color: 'white',
                                            formatter: '{b}\n{c} 所',
                                        }
                                    },
                                    data: [
                                        {
                                            value: unionSchoolTypeNum[0][0],
                                            // value: (unionSchoolTypeNum[0][0]/(unionSchoolTypeNum[0][0] + unionSchoolTypeNum[1][0] + unionSchoolTypeNum[2][0])*100).toFixed(2), 
                                            name: '中学'
                                        },
                                        {
                                            value: unionSchoolTypeNum[1][0],
                                            // value: (unionSchoolTypeNum[1][0]/(unionSchoolTypeNum[0][0] + unionSchoolTypeNum[1][0] + unionSchoolTypeNum[2][0])*100).toFixed(2),
                                            name: '小学'
                                        },
                                        {
                                            // value: (unionSchoolTypeNum[2][0]/(unionSchoolTypeNum[0][0] + unionSchoolTypeNum[1][0] + unionSchoolTypeNum[2][0])*100).toFixed(2), 
                                            value: unionSchoolTypeNum[2][0],
                                            name: '幼儿园'
                                        },
                                    ].sort(function (a, b) {
                                        return b.value - a.value;
                                    }),
                                }
                            ]
                        },
                        'dynamicFunc': schoolTypePieChange
                    }
                ]
            }
            let chartConfig = frontDataNew['charts'][+(props.chartId)];
            chart.setOption(chartConfig['chartOpt'])
            if (chartConfig['dynamicFunc'] !== undefined) {
                setInterval(
                    function () {
                        chartConfig['dynamicFunc'](chart)
                    }, 3000
                );
            }


            console.log("jsonData", jsonData);
        })
        .catch(function (error) {
            console.log(error.message);
        });




    // setTimeout(() => {
    //     let chartConfig = frontDataNew['charts'][+(props.chartId)];
    //     chart.setOption(chartConfig['chartOpt'])
    //     if (chartConfig['dynamicFunc'] !== undefined) {
    //         setInterval(
    //             function () {
    //                 chartConfig['dynamicFunc'](chart)
    //             }, 3000
    //         );
    //     }
    //     // TODO: window.onsize doesn't work on components
    //     window.onresize = function () {
    //         chart.resize();
    //     };
    // }, 1000)


});
</script>

<style lang='scss'>
$orders: 1, 2, 3, 4, 5, 6, 7, 8;

div.border-box {
    width: 30vh;
    height: 30vh;

    @each $order in $orders {
        &[order='#{$order}'] {
            order: $order;
        }
    }

    &[styleId='1'] {
        width: 28vw;
        height: 32vh;
        // margin-top: 1vh;
        margin-left: 1vw;
    }

    &[styleId='2'] {
        width: 28vw;
        height: 36vh;
        margin-left: 1vw;
        margin-bottom: 1vh;
    }

    &[styleId='3'] {
        width: 22vw;
        height: 40vh;
        margin-top: 1vh;
    }

    &[styleId='4'] {
        width: 22vw;
        height: 42vh;
        margin-bottom: 1vh;
    }

    &[styleId='5'] {
        width: 20vw;
        height: 36vh;
        // margin-bottom: 1vh;
        margin-left: 1vw;
        z-index: 12;
    }

    &[styleId='6'] {
        width: 20vw;
        height: 32vh;
        margin-bottom: 1vh;
        margin-left: 1vw;
        z-index: 12;
    }
}

div.chart-container {
    border-radius: 0.4em;
    transition: transform 1s ease-in-out;

    &[styleId='1'] {
        position: absolute;
        left: 1%;
        bottom: 1%;
        height: 98%;
        width: 98%;
    }

    &[styleId='2'] {
        position: absolute;
        left: 1%;
        bottom: 1%;
        height: 98%;
        width: 98%;
    }

    &[styleId='3'] {
        width: 22vw;
        height: 40vh;
        margin-top: 1vh;
    }

    &[styleId='4'] {
        width: 22vw;
        height: 42vh;
        margin-bottom: 1vh;
    }

    &[styleId='5'] {
        width: 20vw;
        height: 36vh;
        // margin-bottom: 1vh;
    }

    &[styleId='6'] {
        width: 20vw;
        height: 32vh;
        margin-bottom: 1vh;
        // margin-left: 1vw;
    }

    div {
        canvas {
            border-radius: 0.4em;
        }
    }
}
</style>